// import http from '../http';

const stakeholderGroup = {}
export default stakeholderGroup;
